import { User } from "./user";
import { PurchaseOrderLine } from "./purchase-order-line";

export class PurchaseOrder {
    id:number = 0;
    supplier_id:number = 0;
    supplier_name:string = '';
    reference:string = '';
    doc_date:Date = new Date();
    delivery_date:Date = new Date();
    description:string = '';
    status:string = 'Abierto';
    user_id:number = 0;
    user:User = new User();
    lines:PurchaseOrderLine[] = [];
    selected:boolean = false;
    delivery_type:string = 'Transporte Por Asignar';
    payment_terms:string = 'Contado';
    authorized:boolean = false;
    authorized_by:User = new User();
}
